
type ShaderParseResult = {
    uniforms: string[],
    attributes: string[],
    defines: string[]
}

export class ShaderSourceParser {
    public parse(source: string): ShaderParseResult {

        let attributes: string[] = [];
        let uniforms: string[] = [];
        let defines: Set<string> = new Set<string>();

        let attrRegex = /^attribute\s+[a-z0-9]+\s+([a-z0-9]+)\s*;$/mig;
        let matchAttr: RegExpExecArray | string[];
        while (matchAttr = attrRegex.exec(source)) {
            attributes.push(matchAttr[1]);
        }

        let uniformRegex = /^uniform\s+[a-z0-9\[\]]+\s+([a-z0-9\[\]]+)\s*;$/mig;
        let matchUniform: RegExpExecArray | string[];
        while (matchUniform = uniformRegex.exec(source)) {
            uniforms.push(matchUniform[1]);
        }

        let defineRegex = /^#[a-z]+\s+SPI_([a-z0-9_]+)$/mig;
        let matchDefine: string[] | RegExpExecArray;
        while (matchDefine = defineRegex.exec(source)) {
            defines.add(matchDefine[1]);
        }

        return {
            uniforms: uniforms,
            attributes: attributes,
            defines: [...defines]
        };
    }

    public merge(...results: ShaderParseResult[]): ShaderParseResult {
        let attributes = new Set<string>();
        let uniforms = new Set<string>();
        let defines = new Set<string>();

        for (let result of results) {
            result.attributes.forEach(attr => attributes.add(attr));
            result.uniforms.forEach(uniform => uniforms.add(uniform));
            result.defines.forEach(define => defines.add(define));
        }

        return {
            attributes: [...attributes],
            uniforms: [...uniforms],
            defines: [...defines]
        };
    }

    public preprocess(source: string, settings: string[]): string {
        let parseResult = this.parse(source);
        let map = new Map<string, boolean>();
        parseResult.defines.forEach(def => map.set(def, false));
        settings.forEach(def => map.set(def, true));

        let lines: string[] = [];
        map.forEach((enabled, setting) => {
            lines.push(`var ${setting} = ${enabled};`);
        });
        lines.push(`var result = '';`);

        let preprocessRegex = /#([a-z]+)\s*(?:SPI_([a-z0-9_]+))?/i;
        for (let line of source.split('\n')) {
            let match = preprocessRegex.exec(line);
            if (match) {

                switch (match[1]) {
                    case 'ifdef':
                        lines.push(`if (${match[2]}) {`);
                        break;
                    case 'ifndef':
                        lines.push(`if (!${match[2]}) {`);
                        break;
                    case 'else':
                        lines.push(`} else {`);
                        break;
                    case 'endif':
                        lines.push(`}`);
                        break;
                }
            } else {
                lines.push(`result += \`${line}\\n\`;`);
            }
        }

        let result = eval(lines.join('\n')) as string;
        while (result.indexOf('\n\n') != -1) {
            result = result.replace('\n\n', '\n');
        }
        return result;
    }
}